import { useState, useEffect } from 'react';

const useDeviceWidth = () => {
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isSmallWidth = screenWidth < 750;

  return { screenWidth, isSmallWidth };
};

export default useDeviceWidth;